<script lang="ts">
    import { QueryClientProvider } from '@sveltestack/svelte-query';
    import { createHistory, createMemorySource, Route, Router } from 'svelte-navigator';
    import Header from './components/Header.svelte';
    import Footer from './components/Footer.svelte';
    import RouteGuard from './RouteGuard.svelte';
    import Dailer from './screens/Call/Dailer.svelte';
    import Chat from './screens/Chat/Page.svelte';
    import Home from './screens/Home/index.svelte';
    import Rate from './screens/Feedback/Rate.svelte';
    import Message from './screens/Feedback/Message.svelte';
    import PageNotExists from './screens/PageNotExists.svelte';
    import { getWidgetConfig } from './domain/session/receivers.actions';
    import authState from './store/auth';
    import widgetStore from './store/widget';
    import { useCti } from './services/hook';
    import { onMount } from 'svelte';
    import { initSentry } from './services/utils'
    import Tailwind from "./Tailwind.svelte";
    import pubsub from 'sweet-pubsub';
    import type { WidgetState } from './types/state';
    import Icon from './components/Icon.svelte';

    const memoryHistory = createHistory(createMemorySource());

    const configureCss = (config) => {
        const {
            primary_bg_color, 
            primary_text_color, 
            secondary_bg_color, 
            secondary_text_color
        } = config
        if (secondary_bg_color) document.body.style.setProperty('--secondary-text-color', secondary_bg_color);
        if (primary_bg_color) document.body.style.setProperty('--primary-bg-color', primary_bg_color);
        if (primary_text_color) document.body.style.setProperty('--primary-text-color', primary_text_color);
        if (secondary_text_color) document.body.style.setProperty('--secondary-text-color', secondary_text_color);
    }

    const setupConfig = async () => {
        const existingConfig: WidgetState = $widgetStore;
        if ( !existingConfig.widget_type ) {
            loading = true
            try{
                const config = await getWidgetConfig();
                widgetStore.set(config)
                configureCss(config)
                const { business_numbers: number } = config;
                pubsub.emit("number_selected", number)
                window.parent.postMessage(config, "*")
                // console.log($widgetStore)
            } catch(e){}
            finally {
                loading = false
            }
        } else {
            loading = false
        }
    }

    let loading = true

    onMount(async () => {
        initSentry()
        // authState.login("pk_3e2oQuuUSG7r6S562FYqlDC4jjfyb")
        const query = new URLSearchParams(window.location.search);
        const authKey = process.env.STERLING_KEY

        if (authKey) {
            authState.login(authKey);
            await setupConfig()
        }

        window.addEventListener('message', async function(event) {
            const { data } = event
            
            const { auth, maximized, ...hooks } = data;
            if ( auth ) {
                authState.login(auth);
            }
            useCti(hooks);
            await setupConfig()
        });
    });

</script>
<Tailwind />
<QueryClientProvider>
    <main class="conatainer">
        {#if loading}
        <div class="flex mx-4 primary-text-color justify-center items-center h-screen">
            <span class="animate-spin mx-2">
                <Icon 
                    icon="loading" 
                    size={24} 
                    color="var(--primary-text-color)" 
                />
            </span>
        </div>
        {:else}
        <Header />
        <Router history={memoryHistory}>
            <div class="main">
                <Route exact path="/">
                    <Home />
                    <!-- <Rate /> -->
                </Route>
                <RouteGuard path="/chat">
                    <Chat />
                </RouteGuard>
                <RouteGuard path="/call">
                    <Dailer />
                </RouteGuard>
                <RouteGuard path="/rate">
                    <Rate />
                </RouteGuard>
                <RouteGuard path="/message">
                    <Message />
                </RouteGuard>
            </div>
            <Route>
                <PageNotExists />
            </Route>
        </Router>
        <Footer />
        {/if}
    </main>
</QueryClientProvider>

<style>
    .main {
        height: 100%;
        overflow: hidden;
    }
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
    .primary-bg-color {
        background-color: var(--primary-bg-color)
    }
    .secondary-bg-color {
        background-color: var(--secondary-bg-color)
    }
</style>
